(function(){
    'use strict';
    angular.module('app').controller('FuelLeviesController', FuelLeviesController);
    FuelLeviesController.$inject = [
        '$uibModalInstance',
        'hasDuplicate',
        'aborter',
        'toastr',
        'FuelLevySpecialInstructionsConst',
        'levy',
        'currencies',
        'serviceDetailsList',
        'ConfirmationModalFactory',
        'Carrier',
        '$rootScope'
    ];

    function FuelLeviesController(
        $uibModalInstance,
        hasDuplicate,
        aborter,
        toastr,
        FuelLevySpecialInstructionsConst,
        levy,
        currencies,
        serviceDetailsList,
        ConfirmationModalFactory,
        Carrier,
        $rootScope
    ) {
        const vm = this;
        vm.levy = angular.copy(levy) || {};
        vm.carriers = removeBreakBulkFromList(serviceDetailsList.carriers);
        vm.currencies = currencies;
        vm.recipients = [];

        vm.onCarrierSelect = onCarrierSelect;
        vm.apply = apply;
        vm.dismiss = dismiss;
        vm.toggleChanged = toggleChanged;
        vm.roundDown = roundDown;
        vm.checkDups = checkDups;
        vm.removeRecipient = removeRecipient;
        vm.addRecipients = addRecipients;

        const viewConfirmation = new ConfirmationModalFactory({}, {
            message: 'messages.warning.viewChange.MESSAGE',
            code: 'messages.warning.viewChange.CODE',
        });

        init();

        function init() {
            preloadNotificationEmail();
            initProfile(vm.carriers, vm.levy);
        }

        function initProfile() {
            if(!vm.levy.carrier){
                vm.levy.carrier = vm.carriers[0];
            }
            if(vm.levy.carrier){
                populateServices(vm.levy.carrier.services);
            }
            if(vm.levy.notificationDate) {
                preloadExpiryDate();
            }
            initService();
            initCurrency(vm.levy);
            vm.levyRaw = angular.copy(vm.levy);
        }

        function preloadExpiryDate() {
            if (!vm.levy.notificationDate) { return; }
            const defaultDate = moment(vm.levy.notificationDate).format('YYYY-MM-DD');
            vm.expiryDate = new Date(defaultDate);
        }

        function initService(){
            if(!vm.levy.service){
                vm.levy.service = vm.services[0];
            }
        }

        function initCurrency(levy) {
            vm.levy.currencyObj = vm.currencies.find(curr=>{
                return curr.currencyCode === levy.currency;
            });
            if(!vm.levy.currencyObj){
                vm.levy.currencyObj = vm.currencies.find(curr=>{
                    return curr.currencyCode === $rootScope.GlobalProfile.office.currency || 'AUD';
                });
            }
            levy.currency = vm.levy.currencyObj.currencyCode || $rootScope.GlobalProfile.office.currency || 'AUD';
        }

        function roundDown(model) {
            return parseFloat(model).roundDown(2);
        }

        function toggleChanged(e) {
            if (vm.isViewMode && angular.equals(cleanPayload(vm.levy), cleanPayload(vm.levyRaw))) {
                vm.isViewMode = false;

                event.preventDefault();
                viewConfirmation.getInstance().result.then(function (cond) {
                    if (cond) {
                        $timeout(function () {
                            vm.isViewMode = true;
                            vm.carrier = angular.copy(vm.carrierRaw);
                            buildCarrierSettingsTable(getMappedSettings(vm.parentCarrier.settings, vm.carrier.settings));
                            $scope.clientDetailsForm.$setUntouched();
                        });
                    }
                });
            }
            else {
                ViewChangeNotificationFactory.showNofication(vm.isViewMode);
                $scope.clientDetailsForm.$setUntouched();
            }
        }

        function onCarrierSelect(services) {
            vm.levy.service = null;
            getFuelLevyUrl(vm.levy.carrier.id);
            populateServices(services);
            initService();
        }

        function populateServices(services) {
            vm.services = [{
                name: 'All Services',
                id: null
            },...services];
        }

        function checkDups(model) {
            if(!model){ return false; }
            vm.checkingDups = true;
            aborter(()=>{
                hasDuplicate({
                    serviceCallback: Carrier.getFuelLevies,
                    callbackFormat: ['success', 'error', 'filter'],
                    raw: levy ? levy.name : '',
                    findBy: 'content',
                    compareWith: model,
                    compareBy: 'name',
                    filters: {
                        size: 1,
                        name: model
                    }
                }).then(res=>{
                    if(res)
                        vm.hasDuplicateTooltip = 'Fuel levy name taken';
                    else
                        vm.hasDuplicateTooltip = null;
                    vm.checkingDups = false;
                }).catch(err=>{
                    vm.checkingDups = false;
                });
            },500);
        }

        function apply(form) {
            form.$setSubmitted();
            if(form.$invalid){ return false; }
            vm.isSaving = true;
            if(vm.levy.id){
                Carrier.updateFuelLevy(vm.levy.id, ()=>{
                    vm.isSaving = false;
                    toastr.success('Fuel levy update');
                    $uibModalInstance.close();
                }, error=>{
                    toastr.error('Unable to update fuel levy', error.message);
                },  cleanPayload(vm.levy));
            }else{
                Carrier.createFuelLevy(()=>{
                    vm.isSaving = false;
                    toastr.success('Fuel levy create');
                    $uibModalInstance.close();
                }, error=>{
                    toastr.error('Unable to create fuel levy', error.message);
                }, cleanPayload(vm.levy));
            }
        }

        function cleanPayload(data) {
            return {
                name: data.name,
                carrierId: angular.getObjVal(data, 'carrier.carrierId')
                    || angular.getObjVal(data, 'carrier.id') || null,
                serviceId: angular.getObjVal(data, 'service.serviceId')
                    || angular.getObjVal(data, 'service.id') || null,
                fixed: data.fixed,
                percentage: data.percentage,
                active: data.active,
                currency: data.currency,
                notificationEmails: vm.recipients.map(email => email.label),
                fuelSurchargeDetailsURL: data.fuelSurchargeDetailsURL,
                notificationDate: vm.expiryDate ? moment(vm.expiryDate).format('YYYY-MM-DD') : null
            }
        }
        function dismiss() {
            $uibModalInstance.dismiss();
        }

        function removeBreakBulkFromList(carriers) {
            return carriers.filter(data => data.id !== 'break-bulk');
        }

        function hasDuplicate(needle, hayStack) {
            if (!hayStack) {return false;}
            let dup = hayStack.filter(val=>{
                return needle === val.label;
            });
            return dup.length !== 0 ? true : false;
        }

        function removeRecipient(item) {
            let newData = vm.recipients.filter(val=>{
                return item.$$hashKey !== val.$$hashKey;
            });
            vm.recipients = newData;
        }

        function addRecipients(data) {
            if (!data) { return; }
            if (hasDuplicate(data, vm.recipients)) {
                toastr.clear();
                toastr.warning("Email is already in the list", "Please check your form");
                return;
            }

            let tmpData = {label: data};
            vm.recipients.push(tmpData);
            vm.recipientEmail= '';
        }

        function getFuelLevyUrl(carrierId) {
            const levy = FuelLevySpecialInstructionsConst.find(data => data.carrierId === carrierId);
            if (!levy) {
                vm.levy.fuelSurchargeDetailsURL = null;
                return;
            }
            vm.levy.fuelSurchargeDetailsURL = levy.url;
        }

        function preloadNotificationEmail() {
            if (!vm.levy.notificationEmails) { return; }
            vm.recipients = vm.levy.notificationEmails.map(data => {
                return {
                    label: data
                }
            });
        }
    }
})();


// WEBPACK FOOTER //
// ./js/controllers/carriers/FuelLeviesModalController.js